"use client";

import { useEffect } from "react";
import { reportAppRouterBoundaryError } from "../../components/error-boundary/report-app-router-error";

interface V3ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// Last-resort boundary for app/v3/[...slug]. The canvas already isolates a
// single organism, so reaching here means the failure was in the page or
// something the canvas could not catch (a nested child, a client leaf).
//
// Does not reuse app/components/error-boundary/dds-error-display: that lazily
// imports a Bit package, and v3 ships none. Same reason as organism-error.tsx.
//
// Caveat carried over from the v2 boundary: this does NOT catch a throw in the
// sibling layout.tsx — that bubbles to app/error.tsx and loses the chrome.
export default function V3Error({ error }: V3ErrorProps) {
  useEffect(() => {
    reportAppRouterBoundaryError("AppRouter:V3Slug", error);
  }, [error]);

  return (
    <p
      role="alert"
      style={{
        margin: "24px",
        fontSize: "16px"
      }}
    >
      Page error. Some content may not be available. Refresh the page or try again later.
    </p>
  );
}
